export default "__VITE_ASSET__MnRHmxky__"